module.exports = __webpack_public_path__ + "static/img/12.f61d7e5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer4/ban-en/12.jpg
// module id = Uah8
// module chunks = 1